/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Folder Zip (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_FOLDER_ZIP_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 176 176" width="176" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#F5F5F5"
    />
    <path
      className="svg-path-primary"
      d="M128.5 54.0005H88.4999L81.4499 46.9505C79.5499 45.0505 76.9999 44.0005 74.3499 44.0005H48.4999C42.9999 44.0005 38.5499 48.5005 38.5499 54.0005L38.4999 114C38.4999 119.5 42.9999 124 48.4999 124H128.5C134 124 138.5 119.5 138.5 114V64.0005C138.5 58.5005 134 54.0005 128.5 54.0005ZM118.5 84.0005H108.5V94.0005H118.5V104H108.5V114H98.4999V104H108.5V94.0005H98.4999V84.0005H108.5V74.0005H98.4999V64.0005H108.5V74.0005H118.5V84.0005Z"
      fill="#707070"
    />
    <circle cx="132" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.834C118.636 107.834 107.833 118.636 107.833 132.001C107.833 145.365 118.636 156.167 132 156.167C145.364 156.167 156.166 145.365 156.166 132.001C156.166 118.636 145.364 107.834 132 107.834Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
  </svg>
);
